<template>
  <PortalPageShell
    :title="pageTitle"
    :subtitle="pageSubtitle"
  >
    <div class="portal-form-card edit-gate form-group">
      <div class="my-2">
        <div class="loader" v-if="loading"></div>
        <input class="form-control" type="text" id="display_name" :placeholder="$t('gate.editgate.name')" v-model="gate.display_name"/><br />
        <div v-if="this.$router.currentRoute.name == 'edit-gate'" class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="customSwitches" v-model="gate.is_active" />
          <label class="custom-control-label mt-4" for="customSwitches">{{ $t("gate.editgate.isactive") }}</label>
        </div>
      </div>
      <button v-if="this.$router.currentRoute.name == 'edit-gate'" class="btn btn-primary mx-2" @click="updateGate($route.params.editid)" >{{ $t("gate.editgate.btn") }}</button>
      <button v-if="this.$router.currentRoute.name == 'new-gate'" class="btn btn-success" @click="addGate">{{ $t("addGate.btngate")}}</button>
    </div>
  </PortalPageShell>
</template>
<script>
import PortalPageShell from '../layout/PortalPageShell.vue';
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
export default {
  name: 'Gate',
  components: {
    PortalPageShell,
  },
  data: function () {
    return {
      loading: false,
      gateData: '',
      switchValue: false,
      gate: {
        display_name: '',
        is_active: '',
      },
      nameCheck: ''
    };
  },
  mounted() {
    if(this.$router.currentRoute.name == 'edit-gate'){
      this.gate.display_name = this.$route.params.display_name;
      this.gate.is_active = this.$route.params.is_active;
      this.nameCheck = this.$route.params.display_name;
    }
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    pageTitle() {
      return this.$router.currentRoute.name === 'new-gate'
        ? this.$t('addGate.title')
        : this.$t('gate.editgate.title');
    },
    pageSubtitle() {
      return this.$router.currentRoute.name === 'new-gate'
        ? this.$t('portal.gateManager')
        : this.$t('gate.editgate.title');
    },
  },
  methods: {
    getOne(idx) {
      axios.get(this.$hostName + '/gate/' + idx).then((response) => {
        this.gateData = response.data;
      });
    },
    addGate(){
      if(this.gate.display_name==''){
        this.$alert('Enter Gate Name');
      }
      else{
        this.loading =  true;
        axios.post(this.$hostName + '/gate/store',{
          gate: this.gate
        })
        .then( response =>{
          if(response.status==202){
              this.loading = false;
              this.$alert('Gate Already Exists');
            }
          else{
            this.gate.display_name='';
            this.loading =  false;
            this.$router.push({name:routeNames.manageGate});
          }
        })
        .catch(error=>{
          console.log(error);
        });
      }
    },
    updateGate(idx) {
      if (this.gate.display_name == '') {
        this.$alert('Enter Gate Name');
      } else {
        this.loading = true;
        axios
          .put(this.$hostName + '/gate/' + idx, {
            gate: this.gate,
            nameCheck: this.nameCheck
          })
          .then((response) => {
            if (response.status == 202) {
              this.loading = false;
              this.$alert('Gate already exists');
            } else {
              this.loading = false;
              this.$router.push({name: routeNames.manageGate});
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
  },
};
</script>
<style scoped>
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url('../../assets/loading.gif');
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
</style>
